import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from 'components/common/Button';

const propTypes = {
  url: PropTypes.string.isRequired,
  closeUspPage: PropTypes.func.isRequired,
};

const UspPage = (props) => (
  <iframe
    className="usp-iFrame"
    id="uspPageIFrame"
    src={props.url}
  >
    <FormattedMessage id="error.iframe_support" />
    <Button type="button" onClick={props.closeUspPage}>
      <FormattedMessage id="navigation.next" />
    </Button>
  </iframe>
);

UspPage.propTypes = propTypes;

export default UspPage;
